import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TooltipModalComponent } from '../tooltip-modal/tooltip-modal.component';
import { PopoverController } from '@ionic/angular';
import { CartService } from '../../../modules/cart/service/cart.service';
import { AppData } from '../../services/app-data.service';
import { IonDatetime } from '@ionic/angular';
@Component({
  selector: 'app-delivery-slot',
  templateUrl: './delivery-slot.component.html',
  styleUrls: ['./delivery-slot.component.scss'],
})
export class DeliverySlotComponent implements OnInit {

   @Input() outletId: string = '';
   @Input() scheduleEnabled: boolean = false;
   @Input() existingSelectedSlot: any;
   @Output() onTimeSlotAdded: EventEmitter<any> = new EventEmitter();
   @Output() dataEmitter = new EventEmitter<string>();
   @Input() disabled: boolean = false;
   @Input() existingLabel: string = '';
   @Input() existingDate: string = '';

  constructor(
    private popoverController: PopoverController,
    private cartService: CartService
  ) { }
  todayDate = new Date();
  selectedDate: string = this.formatDate(this.todayDate);
  minDate: string = this.formatDate(this.todayDate);
  maxDate: any = new Date();
  timeSlots: string[] = [];
  allSlotsData;
  selectedSlot: any = null;
  slideOpts = {
    slidesPerView: 'auto',
    spaceBetween: 12,
    freeMode: true,
  };
  deliveryDate!: IonDatetime;

  ngOnInit() { 
    if(this.existingDate) {
      this.selectedDate = this.existingDate;
      this.getSlots();
    }
   }

  ionViewDidEnter() {
    console.warn('Existing Selected Slot:', this.existingSelectedSlot);
  }


  private formatDate(date: Date): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  sendDataToParent() {
    this.dataEmitter.emit(this.selectedDate);
  }

  openDatePicker() {
    // Access native element
    const input = (this.deliveryDate as any).el.querySelector('input');
    if (input) {
      input.click();
    }
  }

  getSlots() {
    this.sendDataToParent();
    this.cartService.scheduleSlot(this.outletId, this.selectedDate).then((res) => {
      if(res["body"]["data"] && res["body"]["code"] === 200) {
        this.allSlotsData = res["body"]["data"];
        this.timeSlots = this.allSlotsData['slots'].map(slot => slot.label);
        if(this.existingLabel){
          this.selectedSlot = this.allSlotsData['slots'].find(s => s.label === this.existingLabel) || '';
        } else {
          this.selectedSlot = '';
        }
      } 
    });
  }

  onDateChange(event: any) {
    this.selectedDate = this.formatDate(new Date(event.detail.value));
    this.getSlots();
  }

  onToggleSchedule() {
    if (!this.scheduleEnabled) {
      this.selectedSlot = null;
      this.timeSlots = [];
      this.selectedDate = this.formatDate(this.todayDate);
      this.allSlotsData = null;
      this.sendDataToParent();
    }   
  }

  selectSlot(slot: string) {
    this.selectedSlot = this.allSlotsData['slots'].find(s => s.label === slot);
    try{
        let dataObject = {
          "cartId" : AppData.cartId,
          "schedule" : {
            "endTime": this.selectedSlot.endTime,
            "label": this.selectedSlot.label,
            "startTime": this.selectedSlot.startTime
          }
        }
        this.cartService.secheduleDelivery({data: dataObject}).then((res) => {
          this.onTimeSlotAdded.emit('TimeSlotAdded');
          console.log('Delivery slot scheduled successfully');
        });
    } catch (error) {
      console.log(error);
    }
  }

  async showTooltip() {
      const popover = await this.popoverController.create({
        component: TooltipModalComponent,
        cssClass: 'tooltip-popover',
        translucent: true,
        showBackdrop: true,
        backdropDismiss: true,
        mode: 'ios',
        componentProps: {
          title: this.allSlotsData?.scheduleMsgs?.tooltip?.title || '',
          description: this.allSlotsData?.scheduleMsgs?.tooltip?.desc || '',
          btnText: this.allSlotsData?.scheduleMsgs?.tooltip?.btnTitle || ''
        }
      });
      return await popover.present();
    }

  //   async addTimeSlot() {
  //     try{
  //       let dataObject = {
  //         "cartId" : AppData.cartId,
  //         "schedule" : {
  //           "endTime": this.selectedSlot.endTime,
  //           "label": this.selectedSlot.label,
  //           "startTime": this.selectedSlot.startTime
  //         }
  //       }
  //       this.cartService.secheduleDelivery({data: dataObject}).then((res) => {
  //         this.onTimeSlotAdded.emit('TimeSlotAdded');
  //         console.log('Delivery slot scheduled successfully');
  //       });
  //   } catch (error) {
  //     console.log(error);
  //   }
  // }

    addTimeSlot() {
      try{
        this.getSlots();
      } catch (error) {
        console.log(error);
      }
    }
}
